import { FEATURE_FLAG_KEYS } from '../../config/growthbook';

export const FEATURE_FLAGS_ENABLED = 'featureFlagsEnabled';
export const NEW_AGENT_EXPERIENCE = 'new_agent_experience';
export const UK_ENVIRONMENT_ENABLED = 'ukEnvironmentEnabled';
export const AU_ENVIRONMENT_ENABLED = 'auEnvironmentEnabled';
const PRIME_ONE_DYNAMIC_FIELDS = 'prime_one_x_dynamic_fields';
export const SUBMISSIONS_VIEW = 'submissions_view';
export const ASK_MOO_ENABLED = 'askMooEnabled';
export const RENEWAL_SUBMISSION_CONFIDENCE_UI =
  'renewal_submission_confidence_ui';

export const GROWTHBOOK_FEATURE_SETTINGS = {
  FEATURE_FLAGS_ENABLED,
  NEW_AGENT_EXPERIENCE,
  UK_ENVIRONMENT_ENABLED,
  AU_ENVIRONMENT_ENABLED,
  PRIME_ONE_DYNAMIC_FIELDS,
  SUBMISSIONS_VIEW,
  ASK_MOO_ENABLED,
  RENEWAL_SUBMISSION_CONFIDENCE_UI,
} as const;

export type GrowthbookFeature =
  (typeof GROWTHBOOK_FEATURE_SETTINGS)[keyof typeof GROWTHBOOK_FEATURE_SETTINGS];

export const THEME_TYPES = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;
